import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['select', 'image']

  connect () {
    this.images = JSON.parse(this.element.dataset.images)
    const images = this.images
    const image = this.imageTarget

    $(this.selectTarget).select2({
      templateResult: this.formatImage,
      width: '400px',
      minimumResultsForSearch: Infinity,
    }).on('select2:select', function (element) {
      image.src = images[$(this).val()]
    })

    this.selectTarget.visibility = 'hidden'
  }

  open () {
    $(this.selectTarget).select2('open')
  }

  formatImage (state) {
    if (!state.id) {
      return state.text
    }

    const $state = $(
      `<span><img src="${state.element.dataset.imageUrl}" /></span>`,
    )

    return $state
  };
}
